export const reducerTypes = {
  GET_SELECTED_LOCALE: "reducer/GET_SELECTED_LOCALE",
};
